/**
 * @fileoverview Zod schemas for daily contact statistics snapshots.
 * Used for trend graphing of subscriber counts and suppression breakdowns.
 */

import { z } from '@hono/zod-openapi';

export const ContactStatsSchema = z
  .object({
    date: z.string().regex(/^\d{4}-\d{2}-\d{2}$/),
    totalContacts: z.number().int().min(0),

    // Status breakdown (mutually exclusive per contact)
    subscribed: z.number().int().min(0),
    unsubscribed: z.number().int().min(0),
    bounced: z.number().int().min(0),
    spamReported: z.number().int().min(0),

    // Suppression detail (can overlap)
    blocked: z.number().int().min(0),
    invalidEmail: z.number().int().min(0),
    globalUnsubscribed: z.number().int().min(0),
    withSuppressionGroups: z.number().int().min(0),

    // Growth
    newSubscribers: z.number().int().min(0),

    // Metadata
    computedAt: z.string().datetime(),
    computeDurationMs: z.number().int().min(0),
    contactsScanned: z.number().int().min(0),

    created: z.string().datetime(),
    modified: z.string().datetime(),
  })
  .openapi('ContactStats');

export const ContactStatsListResponseSchema = z
  .object({
    stats: z.array(ContactStatsSchema),
    cursor: z.string().nullable(),
    hasMore: z.boolean(),
  })
  .openapi('ContactStatsListResponse');
